<template>
    <v-content>

        <!-- Mobile Drawer -->
        <v-navigation-drawer v-if="isMobile" v-model="drawer" right dark dense transparent persistent enable-resize-watcher fixed app width="180">
            <v-list dense class="pt-4">
                <v-list-tile ripple to="/" v-if="!isHome">
                    <v-list-tile-content class="leftnav-content-text">
                        <v-list-tile-title>Home</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>

                <v-list-tile ripple to="/contact">
                    <v-list-tile-content class="leftnav-content-text">
                        <v-list-tile-title>Contact Us</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>

                <v-list-tile ripple @click="openUrl('https://help.sweldonow.ph'); drawer=false">
                    <v-list-tile-content class="leftnav-content-text">
                        <v-list-tile-title>
                            Knowledge Hub
                            <v-icon small class="ml-1">open_in_new</v-icon>
                        </v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>

                <v-list-tile ripple @click="openUrl('https://app.sweldonow.ph'); drawer=false">
                    <v-list-tile-content class="leftnav-content-text">
                        <v-list-tile-title>
                            Login
                            <v-icon small class="ml-1">open_in_new</v-icon>
                        </v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>

                <v-list-tile ripple to="/book-demo" class="mt-2" v-if="!isBookDemo">
                    <v-list-tile-content class="leftnav-content-text primary--text font-weight-bold">
                        <v-list-tile-title>Book A Free Demo</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-navigation-drawer>

        <!-- Toolbar -->
        <v-toolbar fixed flat clipped-right :class="toolbarcolor" height="70" class="nav-container">
            <!-- Brand Layout Wrapper -->
            <div class="d-flex align-center clickable" @click="gotoHome">
                <img
                    :src="hasScrolledDown ? require('@/assets/logo/idea3-white.png') : require('@/assets/logo/idea3.png')"
                    class="logo-image mr-2"
                    alt="logo">
                <span :class="sweldoNowColor">SweldoNow</span>
            </div>

            <v-spacer></v-spacer>

            <!-- Navigation Links -->
            <v-toolbar-items v-if="!isMobile" class="align-center">
                <v-btn flat :ripple="false" to="/" :class="['nav-link-btn', toolbarFontColorClass]" v-if="!isHome">
                    Home
                </v-btn>

                <v-btn flat :ripple="false" to="/contact" :class="['nav-link-btn', toolbarFontColorClass]">
                    Contact Us
                </v-btn>

                <v-btn flat :ripple="false" @click="openUrl('https://help.sweldonow.ph')" :class="['nav-link-btn', toolbarFontColorClass]">
                    Knowledge Hub<v-icon small class="ml-1">open_in_new</v-icon>
                </v-btn>

                <v-btn flat :ripple="false" @click="openUrl('https://app.sweldonow.ph')" :class="['nav-link-btn', toolbarFontColorClass]">
                    Login<v-icon small class="ml-1">open_in_new</v-icon>
                </v-btn>
                
                <!-- Desktop CTA: Always visible, styling shifts dynamically -->
                <v-btn 
                    v-if="!isBookDemo"
                    to="/book-demo" 
                    :color="hasScrolledDown ? '#FFFFFF' : '#1976D2'"
                    :class="['cta-btn font-weight-bold ml-4 elevation-0', hasScrolledDown ? 'primary--text' : 'white--text']">
                    Book A Free Demo
                </v-btn>
            </v-toolbar-items>

            <v-toolbar-side-icon
                v-if="isMobile"
                :class="isScrolled ? 'white--text' : 'grey--text text--darken-4'"
                @click.stop="drawer=!drawer">
            </v-toolbar-side-icon>
        </v-toolbar>

        <!-- Dialog -->
        <v-dialog v-model="dialog" width="900">
            <legal-docs-viewer ref="refViewer" :dialog.sync="dialog"></legal-docs-viewer>
        </v-dialog>

    </v-content>
</template>

<script>
export default {
    components: {
        'legal-docs-viewer': () => import('@/components/LegalDocsViewer')
    },
    data() {
        return {
            drawer: false,
            dialog: false,
            isScrolled: false
        }
    },
    computed: {
        isHome() {
            return this.$route.name === 'Landing'
        },
        isBookDemo() {
            return this.$route.name === 'BookDemo'
        },
        hasScrolledDown() {
            return this.isScrolled
        },
        toolbarcolor() {
            return this.isScrolled ? 'primary shadow-sm' : 'transparent'
        },
        toolbarFontColorClass() {
            return this.isScrolled ? 'white--text' : 'grey--text text--darken-4'
        },
        sweldoNowColor() {
            return this.isScrolled ? 'logo-text-white' : 'logo-text'
        }
    },
    methods: {
        gotoHome() {
            this.$router.push('/')
        },
        openUrl(url) {
            window.open(url)
        },
        handleScroll() {
            this.isScrolled = window.scrollY >= 80; // Optimized scroll breakpoint
            const primaryBlue = '#1976D2'; 
            const pureWhite = '#FFFFFF';
            const targetColor = this.isScrolled ? primaryBlue : pureWhite;

            let metaThemeColor = document.querySelector('meta[name="theme-color"]');
            if (!metaThemeColor) {
                metaThemeColor = document.createElement('meta');
                metaThemeColor.setAttribute('name', 'theme-color');
                document.head.appendChild(metaThemeColor);
            }
            metaThemeColor.setAttribute('content', targetColor);
        }
    },
    created() {
        window.addEventListener('scroll', this.handleScroll)
        this.handleScroll()
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll)
    }
}
</script>

<style scoped>
.nav-container {
    transition: all 0.3s ease-in-out;
}

.logo-text, .logo-text-white {
    font-family: 'Inter', sans-serif !important;
    font-size: 28px;
    letter-spacing: -0.04em;
    font-weight: 700 !important;
    user-select: none;
}

.logo-text {
    color: #1976D2;
}

.logo-text-white {
    color: #ffffff;
}

.logo-image {
    width: 45px;
    height: 45px;
    object-fit: contain;
}

/* Custom minimal links to override rigid Vuetify defaults */
.nav-link-btn {
    text-transform: none !important;
    font-family: 'Inter', sans-serif !important;
    font-size: 15px !important;
    font-weight: 500 !important;
    letter-spacing: normal !important;
    height: 100% !important;
    box-shadow: none !important;
    background: transparent !important;
}

.nav-link-btn:before {
    display: none !important; /* Removes default background hover box */
}

.nav-link-btn:hover {
    opacity: 0.8;
}

/* Modern Pill CTA Style */
.cta-btn {
    text-transform: none !important;
    font-family: 'Inter', sans-serif !important;
    font-size: 15px !important;
    border-radius: 8px !important;
    height: 42px !important;
    padding: 0 20px !important;
    transition: transform 0.2s ease;
}

.cta-btn:hover {
    transform: translateY(-1px);
}

.shadow-sm {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03) !important;
}
</style>
